import React from 'react';
import { Modal } from 'react-bootstrap'
import Joi from "joi-browser";
import closeBtn from "../../include/media/close.svg";
import { getAppointment, appointmentAllRefund, loadAllAppointment } from "../../store/appointment";
import { toast } from "react-toastify";
import AlertError from "../common/alertError";
import AlertSuccess from "../common/alertSuccess";
import {
    informationSaved,
    failed
} from "../common/misc";
import Form from "../common/form/form";
import { connect } from "react-redux";
import { loadAllDoctor, updateDoctor } from '../../store/doctor';

const initialState = {
    data: {
        rank: "",
    },
    errors: {
        rank: "",
    },
}
class DoctorRank extends Form {
    state = initialState;
    schema = {
        rank: Joi.number()
            .required()
            .label("Rank")
            .error(() => {
                return { message: "Rank field is required." };
            }),
    }
    doSubmit = () => {
        const { rank } = this.state.data;
        var formdata = {
            field_rank: rank,
        }

        const id = this.props.id
        this.props.updateDoctor(id, formdata, this.callback);

    };

    callback = (res) => {
        console.log(res.data.error)
        if (res && res.status === 200) {
          this.props.loadAllDoctor({
            field_type: this.props.field_type,
            page: this.props.currentPage,
            sort_by: this.props.sort_by,
            sort: this.props.sort,
        });
        toast(<AlertSuccess message={informationSaved} />)
        this.setState(initialState)
        }
        else {
            this.setState(initialState)
            this.props.loadAllDoctor({
            page: this.props.currentPage,
            sort_by: this.props.sort_by,
            sort: this.props.sort,
        });
            toast(<AlertError message={res && res.data && res.data.error && res.data.error.error && res.data.error.error.description || res.data.error} />)
        }

        this.props.onHide();

    };
    render() {
        return (
            <div className="modal fade" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                    <div className="modal-content">
                        <Modal
                            {...this.props}
                            aria-labelledby="contained-modal-title-vcenter"
                            centered>
                            <div className="modal-header"><h3></h3>
                                <button type="button" className="close mt-2" data-dismiss="modal" onClick={this.props.onHide}>
                                    <img src={closeBtn} alt="close popup" />
                                </button>
                            </div>
                            <form action="" onSubmit={this.handleSubmit}>
                                <div className="modal-body">
                                    <h3>Doctor rank</h3>
                                    <div className="modal-alert-box">
                                        {this.renderInput("rank", "Rank")}
                                    </div>
                                    <div className="modal-action-btn">
                                        <button type="submit" className="btn btn-delete">Yes</button>
                                        <a href="javascript:void (0)" onClick={this.props.onHide} className="btn btn-cancel" data-dismiss="modal" aria-label="Close">No</a>
                                    </div>
                                </div>
                            </form>
                        </Modal>
                    </div>
                </div>
            </div >
        );
    }
}
const mapStateToProps = (state) => ({
    appointment: getAppointment(state),
    pagination: getAppointment(state).pagination,
});
const mapDispatchToProps = (dispatch) => ({
    loadAllDoctor: (params) => dispatch(loadAllDoctor(params)),
    updateDoctor: (id, data, callback) => dispatch(updateDoctor(id, data, callback)),
});
export default connect(mapStateToProps, mapDispatchToProps)(DoctorRank);
